import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getConditionById } from "services/_conditions";
import "react-quill/dist/quill.snow.css";

const Conditions = () => {
  const { id } = useParams();
  const [conditionData, setConditionData] = useState({});
  const navigate = useNavigate();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const initialData = useCallback(async () => {
    const data = await getConditionById(id);
    if (data.isSuccess) {
      setConditionData(data.data);
    }
  }, [id]);

  useEffect(() => {
    initialData();
  }, [initialData]);

  const handleNavigate = () => {
    navigate("/conditions");
  };

  const imgUrl = conditionData?.image_url;

  return (
    <>
      <div style={{ backgroundColor: "#fff", paddingTop: "20px" }}>
        <section className="py-[30px] bg-white">
          <div className="container">
            <button
              className="font-[600]"
              onClick={handleNavigate}
              style={{
                padding: "15px 0 0 25px",
                fontSize: "18px",
                color: "#0D47A1",
              }}
            >
              <i
                className="fas fa-arrow-left"
                style={{ paddingRight: "10px" }}
              ></i>
              Condition / {conditionData.name}
            </button>
            <div className="grid my_bio  my-[30px] gap-[50px] grid-cols-1 md:grid-cols-5">
              <div className="left_side md:col-span-2 flex justify-center items-center">
                {id ? (
                  <div className="mt-2 bg-[#000d44] rounded-[8px]">
                    <img
                      src={`${BACKEND_URL}${imgUrl}`}
                      alt="Preview"
                      style={{
                        width: "500px",
                        height: "500px",
                        borderRadius: "8px",
                        objectFit: "contain",
                        border: "1px solid lightgray",
                        boxShadow:
                          "1px 2px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)",
                      }}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="right_side md:col-span-3">
                <h1
                  className="md:text-[36px] text-[28px] text-[#225491] font-[700]"
                  style={{ textAlign: "right", paddingTop: "20px" }}
                >
                  {conditionData.name}
                </h1>
                <p
                  className="text-black font-[500]"
                  style={{ textAlign: "right", paddingBottom: "15px" }}
                >
                  {conditionData.short_description}
                </p>
                <hr />
                <p
                  className="text-black font-[500]"
                  style={{ textAlign: "justify", paddingTop: "15px" }}
                  dangerouslySetInnerHTML={{
                    __html: conditionData.detailed_content,
                  }}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default Conditions;
